<script lang="ts">
import { useManualStore } from '@/stores/manualStore.ts'
import { ManualSpell } from '@/stores/spellsStore.ts'
import { storeToRefs } from 'pinia'
import { computed, ComputedRef, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useDesignStore } from '../stores/designStore.ts'
import AbilityDisplayMedallion from './AbilityDisplayMedallion.vue'
import CustomModal from './CustomModal.vue'
import RuleReferenceDoc from './Manual/Rules/RuleReferenceDoc.vue'
import TextToFormattedComponentStructure from './TextToFormattedComponentStructure.vue'

export default {
  emits: ['lookup'],
  props: [
    'title',
    'description',
    'rank',
    'actionCost',
    'resistance',
    'target',
    'area',
    'type',
    'duration',
    'medallion',
    'spellgroup',
    'spellgroups',
    'isPerk',
    'perks',
    'calcOn',
    'anyRankSpellgroup'
  ],
  setup(props, context) {
    const error = ref(null)
    const router = useRouter()
    const designStore = useDesignStore()
    const toggle = ref(true)
    const manualStore = useManualStore()

    const tab = ref('corestats')
    const openReference = ref(false)
    const reference = ref('')

    return {
      designStore,
      tab,
      props,
      toggle,
      openReference,
      reference
    }
  },

  methods: {},
  components: {
    AbilityDisplayMedallion,
    TextToFormattedComponentStructure
  }
}
</script>

<template>
  <div
    style="display: flex; flex-direction: column; width: 100%"
    :style="{ fontFamily: designStore.font }"
  >
    <div
      class="abilityGrid"
      :style="{
        background: designStore.secondaryTheme,
        color: designStore.sidebarText,
        borderColor: designStore.secondaryTheme
      }"
    >
      <div
        class="grid__item"
        :style="{ background: designStore.sidebarBacking, borderColor: designStore.secondaryTheme }"
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            min-height: fit-content;
          "
        >
          <div
            style="
              display: flex;
              justify-content: flex-start;
              height: 100%;
              padding-right: 0.5rem;
              flex-wrap: wrap;
            "
          >
            <div style="align-self: center; text-wrap: nowrap; padding-right: 0.5rem">
              Action Cost:
            </div>
            <div style="align-self: flex-end">{{ props.actionCost }}</div>
          </div>
        </div>
      </div>
      <div
        class="grid__item"
        :style="{ background: designStore.sidebarBacking, borderColor: designStore.secondaryTheme }"
      >
        <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
          <div
            style="
              display: flex;
              justify-content: flex-start;
              height: 100%;
              padding-right: 0.5rem;
              flex-wrap: wrap;
            "
          >
            <div style="align-self: center; padding-right: 0.5rem">Target:</div>
            <div style="align-self: center">{{ props.target }}</div>
          </div>
        </div>
      </div>
      <div
        class="grid__item"
        :style="{ background: designStore.sidebarBacking, borderColor: designStore.secondaryTheme }"
      >
        <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
          <div
            style="
              display: flex;
              justify-content: flex-start;
              height: 100%;
              padding-right: 0.5rem;
              flex-wrap: wrap;
            "
          >
            <div style="align-self: center; padding-right: 0.5rem">Area:</div>
            <div style="align-self: center">{{ props.area }}</div>
          </div>
        </div>
      </div>
      <div
        class="grid__item"
        :style="{ background: designStore.sidebarBacking, borderColor: designStore.secondaryTheme }"
      >
        <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
          <div
            style="
              display: flex;
              justify-content: flex-start;
              height: 100%;
              padding-right: 0.5rem;
              flex-wrap: wrap;
            "
          >
            <div style="align-self: center; padding-right: 0.5rem">Type:</div>
            <div style="align-self: center">{{ props.type }}</div>
          </div>
        </div>
      </div>
      <div
        class="grid__item"
        :style="{ background: designStore.sidebarBacking, borderColor: designStore.secondaryTheme }"
      >
        <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
          <div
            style="
              display: flex;
              justify-content: flex-start;
              height: 100%;
              padding-right: 0.5rem;
              flex-wrap: wrap;
            "
          >
            <div style="align-self: center; padding-right: 0.5rem">Duration:</div>
            <div style="align-self: center">{{ props.duration }}</div>
          </div>
        </div>
      </div>
      <div
        class="grid__item"
        :style="{ background: designStore.sidebarBacking, borderColor: designStore.secondaryTheme }"
      >
        <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
          <div
            style="
              display: flex;
              justify-content: flex-start;
              height: 100%;
              padding-right: 0.5rem;
              flex-wrap: wrap;
            "
          >
            <div style="align-self: center; padding-right: 0.5rem">Resistance:</div>
            <div style="align-self: center">{{ props.resistance }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        border-left: 2px solid;
        border-right: 2px solid;
        border-bottom: 4px solid;
        border-bottom-left-radius: 1rem;
        border-bottom-right-radius: 1rem;
        padding: 0.5rem;
        text-align: left;
      "
      :style="{
        background: designStore.inputBacking,
        color: designStore.inputText,
        borderColor: designStore.secondaryTheme,
        '--sidebar': designStore.sidebarBacking
      }"
    >
      <div
        @click="toggle = !toggle"
        style="z-index: 5; margin-left: 0.75rem; margin-right: 0.75rem; text-align: left"
        :style="{
          borderColor: designStore.secondaryTheme,
          '--secondary': designStore.secondaryTheme,
          '--primary': designStore.primaryTheme,
          '--primary-text': designStore.primaryText
        }"
      ></div>
      <TextToFormattedComponentStructure
        style="padding-left: 0.5rem; padding-right: 0.5rem"
        :calc-on="props.calcOn"
        :spellgroups="props.spellgroups"
        :text="props.description"
        :title="title"
        :definition-help="true"
        :perks="props.perks"
      ></TextToFormattedComponentStructure>
      <AbilityDisplayMedallion :medallion="props.medallion"></AbilityDisplayMedallion>
    </div>
    <div
      style="display: flex; justify-content: center; z-index: 1; width: 100%"
      :style="{
        color: designStore.secondaryTheme,
        borderColor: designStore.secondaryTheme
      }"
    >
      <v-icon
        name="gi-door-ring-handle"
        scale="2"
        style="
          margin-bottom: -1rem;
          position: relative;
          text-align: right;
          bottom: 0.25rem;
          transform: scale(1.25, 1);
          rotate: 180deg;
        "
      ></v-icon>
    </div>
  </div>
</template>

<style>
.abilityGrid {
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  z-index: 4;
  border: 2px solid;
  border-bottom: 2px solid;
  margin-top: -1.5rem;
  grid-gap: 0.05rem;
  justify-content: space-around;
}
.grid__item {
  padding: 0.25rem;
  position: relative;
  padding-left: 0.5rem;
  padding-bottom: 0.5rem;
  padding-top: 0.25rem;
  text-wrap: wrap;
}

.buttonStyle {
  border: 2px solid;
  padding: 0.35rem;
  border-radius: 1rem;
  background: var(--primary);
  border-color: inherit;
  color: var(--primary-text);
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
}
@media (max-width: 1000px) {
  .abilityGrid {
    grid-template-rows: auto auto auto;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
